import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';

import { PreviewService } from '../../../../../services/preview/preview.service';
import { OrbitItem } from '../../../../../../models/orbit-item';

@Component({
  selector: 'dashboard-orbits-config-preview',
  templateUrl: './orbits-config-preview.component.html',
  styleUrls: ['./orbits-config-preview.component.scss'],
})
export class OrbitsConfigPreviewComponent implements OnInit, OnDestroy {
  @Input() initialOrbitItems: OrbitItem[];

  orbitItems: OrbitItem[];
  private subscriptions = new Subscription();

  constructor(private previewService: PreviewService) {}

  ngOnInit(): void {
    this.orbitItems = this.initialOrbitItems;

    this.subscriptions.add(
      this.previewService.previewData$.subscribe((previewData) => {
        if (previewData?.orbitItems?.length) {
          this.orbitItems = previewData?.orbitItems;
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
